import React from 'react';
import {Link} from "react-router-dom";
import Logo from "../../elements/logo/Logo";
import footerOne from "../../data/footer/footerOne.json";
import ScrollTop from "./ScrollTop";
const footerIntem =  footerOne[0];
const footerIntemOne =  footerOne[1];
const footerIntemTwo =  footerOne[2];
const footerIntemThree =  footerOne[3];
const footerIntemFour =  footerOne[4];
const footerIntemFive =  footerOne[5];
const indexOneLink = (footerIntemOne.quicklink);
const indexTwoLink = (footerIntemTwo.quicklink);
const indexThreeLink = (footerIntemThree.quicklink);
import { FiFacebook, FiTwitter, FiInstagram, FiLinkedin, FiYoutube, FiHeadphones , FiMail , FiMapPin } from "react-icons/fi";

const FooterOne = () => {
    return (
        <>
            <footer className="rn-footer footer-style-default">
                <div className="footer-top">
                    <div className="container">
                        <div className="row">
                            {/* Start Single Widget  */}
                            <div className="col-lg-4 col-md-4 col-sm-4 col-12">
                                <div className="rn-footer-widget">
                                    <div className="logo">
                                        <Logo 
                                            image={`${process.env.PUBLIC_URL}/images/logo/uftaa-logo-new.png`}
                                            image2={`${process.env.PUBLIC_URL}/images/logo/uftaa-logo-new.png`}
                                        />
                                    </div>
                                    <h6 style={{color:"rgb(3 1 154)", marginTop: "10px"}}>The United Federation of Travel Agents Associations (UFTAA)</h6>
                                    {/* <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                                        <div className="rn-footer-widget">
                                            <div className="inner">
                                                <ul className="social-icon social-default justify-content-start">
                                            <li><a href="https://www.facebook.com/skalinternational" target="_blank"><FiFacebook />
                                            </a></li>
                                            <li><a href="https://x.com/SKAL_Intl" target="_blank"><FiTwitter /></a></li>
                                            <li><a href="https://www.linkedin.com/company/skal-international-official/" target="_blank"><FiLinkedin /></a></li>
                                            <li><a href="https://www.youtube.com/channel/UCNKK--TH-MczsM5SZby96Dw" target="_blank"><FiYoutube /></a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            {/* End Single Widget  */}

                            {/* Start Single Widget  */}
                            <div className="col-lg-2 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    <div className="widget-menu-top">
                                        <h4 className="title" style={{color: "#2c56a5"}}>{footerIntemOne.title}</h4>
                                        <div className="inner">
                                            <ul className="footer-link link-hover">
                                                {indexOneLink.map((data, index) => (
                                                    <li key={index}><Link to={`${data.url}`}>{data.text}</Link></li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                                
                                </div>
                            </div>
                            {/* End Single Widget  */}

                            {/* Start Single Widget  */}
                            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    
                                    <div className="widget-menu-top">
                                        <h4 className="title"><FiMapPin />
                                        Administrative Office</h4>
                                        <div className="inner">
                                        <div className="inner">
                                        <p>19 Avenue des Castelans,<br /> 98000<br />
                                        Monaco
                                        <br /> 
                                        </p>
                                        </div>
                                        </div>
                                    </div>

                                    
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                                <div className="rn-footer-widget">
                                    
                                    <div className="widget-menu-top">
                                        <h4 className="title">Quick Support</h4>
                                        {/* <div className="inner">
                                        <h4 className="title"><FiHeadphones /> Contact Phone Number</h4>
                                        <p><a href="tel:+919072646471" style={{color:"#c54e4e"}}>+91 90726 46471</a></p>
                                    </div> */}
                                    <div className="inner">
                                        <h4 className="title"> <FiMail /> Our Email Address</h4>
                                        <p><a href="president@uftaa.org" style={{color:"#040399"}}>president@uftaa.org</a></p>
                                    </div>
                                    </div>

                                    
                                </div>
                            </div>
                            {/* End Single Widget  */}

                            {/* Start Single Widget  */}
                           
                            {/* End Single Widget  */}
                        </div>
                    </div>
                </div>
            </footer>
            <ScrollTop />
        </>
    )
}

export default FooterOne
